import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const ProjectBoardAllowed = () => {
	return useFeatureAvailable(Feature.PROJECT_PLAN);
};

export default ProjectBoardAllowed;
